<template>
  <div class="outBox">
    <div class="box">
      <div v-loading="loading" element-loading-text="加载数据中"
           element-loading-spinner="el-icon-loading"
           element-loading-background="rgba(0, 0, 0, 0.2)"
           class="mine"></div>
      <div id="main9" class="chart-container"></div>
    </div>
  </div>

</template>

<script>
import * as echarts from 'echarts';
import { getTrendList } from '@/api/bi'


export default {
  name: "echartsNine",
  data(){
    return {
      chart: null,
      loading: false, // 控制加载效果的显示与隐藏
      lineData: {},
    }
  },
  props: ['params'],
  mounted() {

    this.initData();
    const _this = this;
    this.$nextTick(function () {
      this.$on('resizeEight', function () {
        _this.chart.resize();
      })
    });
  },
  methods:{
    getData(){

    },
    initBar(){
      const _this = this;
      const text = this.params.tp === '1'? '景区数据指标趋势(销售额)':'景区数据指标趋势(退款率)';
      if (!this.lineData || !Array.isArray(this.lineData.data) || this.lineData.data.length < 3) {
        this.lineData = {
          date: [],
          data: [
            { title: '今年数据', value: [] },
            { title: '去年数据', value: [] },
            { title: '前年数据', value: [] },
          ],
        }
      }

      let option = {
        title: {
          text,
          color: '#fff',
          top: 16,

          textStyle:{
            fontSize: 18,
            fontWeight: 'bold',
            color: '#fff',
          }
        },
        // 更改图例默认颜色(依次应用)
        color:['rgb(0, 255, 255, 10)', 'rgb(140, 231, 133, 10)', 'rgb(245, 226, 0, 10)'],
        tooltip: { // 数据展示框
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          },
          formatter: function(params) {
            let str = '';
            let temp  = {
              valueData:'',//值
              seriesName:"", //
              spacespan:'',
            };
            str += params[0].axisValue+'<br />'
            params.forEach((item) => {
              // 做的事情
              temp.seriesName = item.seriesName; //横坐标
              if(_this.params.tp === '1') {
                temp.valueData = item.value + "元";
              } else {
                temp.valueData = (item.value * 100).toFixed(2) + '%'
              }

              temp.spacespan=`<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${item.color};"></span>`;
              str += temp.spacespan + temp.seriesName + "：" + temp.valueData + '<br />'
            })
            return str
          }
        },
        legend: {
          data: [
            // '待下发','处置中','已完成'
            {
              name: '查询数据',
              icon: 'circle',
              textStyle: {
                color: 'rgb(0, 255, 255, 10)'          // 图例文字颜色
              }
            },
            {
              name: '去年数据',
              icon: 'circle',
              textStyle: {
                color: 'rgb(140, 231, 133, 10)'          // 图例文字颜色
              }
            },
            {
              name: '前年数据',
              icon: 'circle',
              textStyle: {
                color: 'rgb(245, 226, 0, 10)'          // 图例文字颜色
              }
            },
          ],
        },
        xAxis: {
          type: 'category',
          axisLabel: {
            inside: false, // y轴名字是否显示在柱状图里面
            zlevel: 2,
            color: '#fff' // y轴名字颜色
          },
          axisTick: {
            show: true
          },
          axisLine: {
            show: true,
            // 坐标轴轴线相关设置。
            lineStyle: {
              color: '#fff'
            }
          },

          data: this.lineData.date
        },
        yAxis: [
          {
            type: 'value',
            axisLine: {
              show: true,
              // 坐标轴轴线相关设置。
              lineStyle: {
                color: '#fff'
              }
            },
            axisLabel: {  // 坐标轴上的文字
              color: '#fff',
              formatter: function (value, index) {
                if(_this.params.tp === '1') {
                  if (value >= 10000) {
                    value = value / 10000 + "万";
                  }
                } else {
                  value = (value * 100).toFixed(2) + '%'
                }

                return value;
              }
            },
            axisTick:{ // 坐标轴刻度线
              show:true
            },
            splitLine:{
              show:false // 不显示网格线
            },
          }
        ],
        dataZoom: [
          {
            type: 'slider',
            start: 0,//数据窗口范围的起始百分比0-100。
            end: 60//数据窗口范围的结束百分比0-100。
          },
        ],
        series: [
          {
            name: this.lineData.data[0].title,
            // ------------------数据及其样式----------------------------
            // 内柱条的数据
            data: this.lineData.data[0].value, // x轴代表的数据
            type: 'line',
            smooth: true,
            lineStyle: { // 线条样式
              normal: {
                width: 4,
                color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [ // 颜色渐变
                  {
                    offset: 0,
                    color: 'rgb(0, 255, 255, 10)'
                  },
                  {
                    offset: 0.2,
                    color: 'rgb(0, 255, 255, 10)'
                  },
                  {
                    offset: 0.4,
                    color: 'rgb(0, 200, 200, 80)'
                  },
                  {
                    offset: 0.6,
                    color: 'rgb(0, 200, 200, 80)'
                  },
                  {
                    offset: 0.8,
                    color: 'rgb(0, 255, 255, 10)'
                  },
                  {
                    offset: 1,
                    color: 'rgb(0, 255, 255, 10)'
                  }
                ])
              }
            }

          },
          {
            name: this.lineData.data[1].title,
            // ------------------数据及其样式----------------------------
            // 内柱条的数据
            data: this.lineData.data[1].value, // x轴代表的数据
            type: 'line',
            smooth: true,
            lineStyle: { // 线条样式
              normal: {
                width: 4,
                color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [ // 颜色渐变
                  {
                    offset: 0,
                    color: 'rgb(140, 231, 133, 10)'
                  },
                  {
                    offset: 0.2,
                    color: 'rgb(140, 231, 133, 10)'
                  },
                  {
                    offset: 0.4,
                    color: 'rgb(140, 231, 133, 80)'
                  },
                  {
                    offset: 0.6,
                    color: 'rgb(140, 231, 133, 80)'
                  },
                  {
                    offset: 0.8,
                    color: 'rgb(140, 231, 133, 10)'
                  },
                  {
                    offset: 1,
                    color: 'rgb(140, 231, 133, 10)'
                  }
                ])
              }
            }

          },
          {
            name: this.lineData.data[2].title,
            // ------------------数据及其样式----------------------------
            // 内柱条的数据
            data: this.lineData.data[2].value, // x轴代表的数据
            type: 'line',
            smooth: true,
            lineStyle: { // 线条样式
              normal: {
                width: 4,
                color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [ // 颜色渐变
                  {
                    offset: 0,
                    color: 'rgb(245, 226, 0, 10)'
                  },
                  {
                    offset: 0.2,
                    color: 'rgb(245, 226, 0, 10)'
                  },
                  {
                    offset: 0.4,
                    color: 'rgb(245, 226, 0, 80)'
                  },
                  {
                    offset: 0.6,
                    color: 'rgb(245, 226, 0, 80)'
                  },
                  {
                    offset: 0.8,
                    color: 'rgb(245, 226, 0, 10)'
                  },
                  {
                    offset: 1,
                    color: 'rgb(245, 226, 0, 10)'
                  }
                ])
              }
            }

          },
        ],


      };

      // 使用刚指定的配置项和数据显示图表（notMerge 避免失败后旧数据残留）
      this.chart.clear();
      this.chart.setOption(option, true);
      // // 隐藏加载效果
      // setTimeout(()=> {
      //   this.loading = false;
      // }, 2000)
    },
    async initData(){
      this.loading = true;
      // 先置空，失败时图表/数据都不保留上一份
      this.lineData = {
        date: [],
        data: [
          { title: '今年数据', value: [] },
          { title: '去年数据', value: [] },
          { title: '前年数据', value: [] },
        ],
      }
      try {
        const res = await getTrendList(this.params)
        if (res && res.code === 2000 && res.data) {
          this.lineData = res.data;
        }
      } catch (e) {
        console.error('获取景区指标趋势失败', e)
      } finally {
        this.loading = false;
      }

      if (!this.chart) {
        const el = document.getElementById('main9')
        if (el) this.chart = echarts.init(el);
      }
      if (this.chart) this.initBar();
    }
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
      this.chart = null;
    }
  }
}
</script>

<style scoped>
.outBox {
  width: 100%;
  height: 320px;
  /*border: 1px solid #4688ff;*/
}

.box {
  width: 100%;
  height: 320px; /* 与组件中的高度一致 */
  position: relative;
}

.mine {
  width: 100%;
  height: 100%; /* 与组件中的高度一致 */
  position: absolute;
  top: 0;
  left: 0;
}

.chart-container {
  width: 100%;
  height: 100%; /* 与组件中的高度一致 */
}


</style>